export type GradeItem = {
	title: string;
	intro: string;
	bg: string;
};

/**
 * 国家文案配置
 */
export const GRADE_COUNTRY_CONIFG: Record<string, GradeItem[]> = {
	'en-US': [
		{
			bg: 'https://web-data.zmlearn.com/image/qQqFoSCumZj4rV5Agdb5gz/20%402x.png',
			title: 'Elementary School',
			intro: `<p>SSAT/ISEE</p><p>Grades 1~7</p><p>English, Maths, Social Studies, Science...</p>`,
		},
		{
			bg: 'https://web-data.zmlearn.com/image/5FqqKEUTLRJc5JtJQJb6jN/21%402x.png',
			title: 'Middle School',
			intro: `<p>Middle School</p><p>Grades 5~8</p><p>English, Maths,Social Studies, Science...</p>`,
		},
		{
			bg: 'https://web-data.zmlearn.com/image/eomL4pMQShAocuG9zQ9vTS/22%402x.png',
			title: 'High School',
			intro: `<p>SAT/ACT/AP</p><p>Grades 9~12</p><p>Writing, Literature, Algebra, Geometry, Physics, Chemistry, Biology, History, Geography, Economics....</p>`,
		},
	],
	'en-CA': [
		{
			bg: 'https://web-data.zmlearn.com/image/qQqFoSCumZj4rV5Agdb5gz/20%402x.png',
			title: 'Primary Education',
			intro: `<p>Primary Education</p><p>Grades 1~6</p><p>English, French, Maths, Science Studies, Social Studies...</p>`,
		},
		{
			bg: 'https://web-data.zmlearn.com/image/5FqqKEUTLRJc5JtJQJb6jN/21%402x.png',
			title: 'Secondary Education',
			intro: `<p>Secondary Education</p><p>Grades 7~12</p><p>English, French, Maths, Science Studies, Social Studies..</p>`,
		},
		{
			bg: 'https://web-data.zmlearn.com/image/eomL4pMQShAocuG9zQ9vTS/22%402x.png',
			title: 'AP',
			intro: `<p>AP</p><p>Grades 9~12</p><p>English, French, Maths, Biology, Chemistry, Physics, Geography, History...</p>`,
		},
	],
	'en-AU': [
		{
			bg: 'https://web-data.zmlearn.com/image/5VSdat5M9vnZYeQKtApSKY/20%402x.png',
			title: 'Primary School',
			intro: `<p>Primary School</p><p>Year 1-6</p><p>English, French, Mathematics...</p>`,
		},
		{
			bg: 'https://web-data.zmlearn.com/image/cZpvBnVrHMTJ8U1nQPdFMP/21%402x.png',
			title: 'Secondary School',
			intro: `<p>Secondary School</p><p>Year 7-10</p><p>English, French, Mathematics, Science...</p>`,
		},
		{
			bg: 'https://web-data.zmlearn.com/image/6VeRjsNnerBBBs4ACWsdeT/22%402x.png',
			title: 'Senior Secondary School',
			intro: `<p>Senior Secondary School</p><p>Year 11-12</p><p>English, French, Mathematics, Biology, Chemistry, Physics...</p>`,
		},
	],
	'en-GB': [
		{
			bg: 'https://web-data.zmlearn.com/image/g8ZaCZ3x1mqt2J2WqabMCX/20%402x.png',
			title: 'Primary School',
			intro: `<p>SATs</p><p>Year 1~6</p><p>Reading, Maths, Grammar, Pronounciation and Spelling...</p>`,
		},
		{
			bg: 'https://web-data.zmlearn.com/image/o5iiFxby7nkAU1vrHq6RWi/21%402x.png',
			title: 'Secondary School',
			intro: `<p>GCSE</p><p>Year 7~11</p><p>Maths, English, Biology, Chemistry, Physics...</p>`,
		},
		{
			bg: 'https://web-data.zmlearn.com/image/f15Lwdvd32gwnFryhHACwd/22%402x.png',
			title: 'Senior High School',
			intro: `<p>A-Level</p><p>Year 12~13</p><p>Maths, English, Biology, Chemistry, Physics...</p>`,
		},
	],
	'en-IE': [
		{
			bg: 'https://web-data.zmlearn.com/image/jwkX6uo2gzX9P8WoAeXKvy/20%402x.png',
			title: 'Primary School',
			intro: `<p>Primary School</p><p>1st Class ~ 6th Class</p><p>English, Gaeilge, Mathematics, Science...</p>`,
		},
		{
			bg: 'https://web-data.zmlearn.com/image/fiGUBvsatgiJ5kqFm6JLD9/21%402x.png',
			title: 'Junior Cycle',
			intro: `<p>Junior Cycle</p><p>1st Year ~ 3rd Year</p><p>English, Gaeilge, Mathematics, Science...</p>`,
		},
		{
			bg: 'https://web-data.zmlearn.com/image/fgB9HFx45R6xhxJhvWWKtA/22%402x.png',
			title: 'Senior Cycle',
			intro: `<p>Senior Cycle</p><p>4th Year - 6th Year</p><p>English, Gaeilge, Mathematics, Biology, Chemistry, Physics...</p>`,
		},
	],
	'en-NZ': [
		{
			bg: 'https://web-data.zmlearn.com/image/jC2fSnBEyUCstRG5Q1FMCk/20%402x.png',
			title: 'Primary School',
			intro: `<p>Primary School</p><p>Year 1-8</p><p>English, French, Maths, Science</p>`,
		},
		{
			bg: 'https://web-data.zmlearn.com/image/iH4iHiHiuf7s52NmRgkw2m/21%402x.png',
			title: 'High School',
			intro: `<p>High School</p><p>Year 9-10</p><p>English, French, Maths, Science</p>`,
		},
		{
			bg: 'https://web-data.zmlearn.com/image/uJrXWgJVyCFTYC6RXfmeMQ/22%402x.png',
			title: 'Senior High School',
			intro: `<p>Senior High School</p><p>Year 11-13</p><p>Biology, Chemistry, Physics</p>`,
		},
	],
};
